<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'ACCOUNT_LIST.TITLE' | translate }}</h3>  
  <!-- Section №1 -->
  <div class="content" id="detail">
    <div class="card-body">
      <p class="left-border header-text2">{{ 'ACCOUNT_LIST.TEXT_1' | translate }}</p>
    </div>
    <!-- Button -->
    <div class="row" style="justify-content: flex-end;" *ngIf="wf_account_list_delete && wf_account_list_detail">
      <button type="button" (click)="deleteAccount()" class="btn-pinkmini btn-pinklng">{{ 'ACCOUNT_LIST.DELETE_ACCOUNT_BUTTON' | translate }}</button>
    </div>
    <!-- 1 -->
    <div class="card-body ">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title"> {{ 'ACCOUNT_MANAGEMENT.NAME_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
            <h3 class="card-title display">{{ Last_Name }}&emsp;{{ First_Name }}</h3>
        </div>
      </div>
    </div>
    <!-- 2 -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title"> {{ 'ACCOUNT_MANAGEMENT.AUTHORITY_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <h3 class="card-title"> {{User_Auth_Name}}</h3>
        </div>
      </div>
    </div>
    <!-- DepartmentName-->
    <div class="card-body"  *ngIf="User_Auth == 'wf-sys-admin' || User_Auth == 'wf-corp-staff' || User_Auth == '' || User_Auth == 'wf-fc-head'">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title"> {{ 'ACCOUNT_MANAGEMENT.DEPARTMENT_NAME' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <h3 class="card-title"> {{Department_Shop}}</h3>
        </div>
      </div>
    </div>
    <!-- ManagementCompany-->
    <div class="card-body" *ngIf="User_Auth == 'wf-fc-head' || User_Auth == 'wf-fc-staff'">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title"> {{ 'ACCOUNT_MANAGEMENT.MANAGEMENT_COMPANY' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <h3 class="card-title"> {{AcquiredData}}</h3>
        </div>
      </div>
    </div>
    <!-- StoreName-->
    <div class="card-body"*ngIf="User_Auth == 'wf-direct-staff' || User_Auth == 'wf-fc-staff'">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title"> {{ 'ACCOUNT_MANAGEMENT.STORE_NAME_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <h3 class="card-title"> {{StoreName}}</h3>
        </div>
      </div>
    </div>
    <!-- E-Mail -->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title"> {{ 'ACCOUNT_MANAGEMENT.MAIL_ADDRESS_DEST' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <h3 class="card-title"> {{Mail_Address}}</h3>
        </div>
      </div>
    </div>

    <div class="card-body"*ngIf="User_Auth == 'wf-fc-head' ">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-dest">
          <h3 class="card-title"> {{ 'ACCOUNT_MANAGEMENT.SEARCH_LIMIT' | translate }}</h3>
        </div>
        <div class="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-meaning">
          <h3 class="card-title" *ngIf="limit == 1">
            {{ 'ACCOUNT_MANAGEMENT.NO_LIMIT' | translate }}
          </h3>
          <h3 class="card-title" *ngIf="limit == 0">
            {{ 'ACCOUNT_MANAGEMENT.LIMITED' | translate }}
          </h3>
        </div>
      </div>
    </div>
    <!-- Button -->
    <div class="text-center" *ngIf="User_Status == '0'">
      <div class="two-btn">
        <div class="display">
          <a (click)="resend()" class="btn-pink btn-resend">
            {{ 'ACCOUNT_MANAGEMENT.RESEND_ACCOUNT_ISSUANCE_EMAIL_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
    <!-- Button -->
    <div class="text-center">
      <div class="two-btn">
        <div class="display">
          <a (click)="back()" class="btn-grey">{{ 'COMMON.COMMON_BACK_BUTTON' | translate }}
          </a>
        </div>
        <div class="display" *ngIf="wf_account_list_modify && wf_account_list_detail">
          <a (click)="next()" class="btn-pink">{{ 'ACCOUNT_LIST.ACCOUNT_MODIFY_BUTTON' | translate }}
          </a>
        </div>
      </div>
    </div>
    <!-- End Button -->
  </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#E10800 " type = "square-jelly-box" [fullScreen]="true"><p style="color: #E10800 " > {{ 'COMMON.LOADING' | translate }} </p>></ngx-spinner>